import React from "react";
import { connect } from "react-redux";

import { formatCurrency } from "../../utils/functions";
import { Tooltip } from "../../utils/components/Tooltip";
import { getProduktInfoIcon } from "../../utils/components/icons";

export const EdelmetallOrder = connect(store => {
  return {
    configStorage: store.configStorage
  };
})((props) => {
  const { warenkorbPos, configStorage, handleRemark } = props || {};
  const headers = [
    "Produkt",
    "Produktpreis netto",
    "MwSt.",
    "Stückzahl",
    "Produktpreis brutto inkl. Konditionsänderung/Gebühr"
  ];
  const renderOrder = (warenkorbPos) => {
    if (!Array.isArray(warenkorbPos)) {
      return <tr><td>Loading...</td></tr>;
    }
    return warenkorbPos.map((data, index) => {
      let row = (
        <tr key={"row_" + (data.id || index)}>
          <td
            className="text-center col-lg-2"
            aria-label=""
          >
            <img
              alt=""
              src={configStorage.getImgUrl(data.image)}
              className="ms-1 border border-color-dark small-image" />
          </td>
          <td
            className="col-lg-2"
            aria-label={headers[0]}
          >
            <span>{data.name}</span>
            <Tooltip icon={getProduktInfoIcon()}>{data.produktInfo}</Tooltip>
          </td>
          <td
            className="text-center col-lg-2"
            aria-label={headers[1]}
          >
            {formatCurrency(data.netto)}
          </td>
          <td
            className="text-center col-lg-2"
            aria-label={headers[2]}
          >
            {formatCurrency(data.mwstBetrag)}
          </td>
          <td
            className="text-center col-lg-2"
            aria-label={headers[3]}
          >
            {data.anzahl}
          </td>
          <td
            className="text-center col-lg-2"
            aria-label={headers[4]}
          >
            {formatCurrency(data.brutto)}
          </td>
        </tr>
      );
      if (configStorage.isMaShop()) {
        row = [row, (
          <tr key={"row2_" + data.id} className="form-group">
            <td className="text-md-end">
              <label
                htmlFor="bemerkung"
                className="fs-5"
              >
                Bemerkung:
              </label>
            </td>
            <td colSpan="5">
              <input
                type="text"
                name="bemerkung"
                className="form-control"
                maxLength="55"
                placeholder={"Optionale Bemerkung zur Bestellposition"}
                aria-label={"Optionale Bemerkung zur Bestellposition " + data.name}
                onChange={e => {
                  if (typeof handleRemark === "function")
                    handleRemark(e, index);
                }}
              />
            </td>
          </tr>
        )];
      }
      return row;
    });
  };

  return (
    <div className="table-responsive table-scroll ser-table">
      <table className="col-12 order-detail table table-responsive table-striped">
        <thead>
          <tr
            className="gray-500 fs-5 fw-bold"
          >
            <th className="col-12 col-lg-2"><span className="aria-visible">Bild</span></th>
            {headers.map((name, index) => {
              return (
                <th key={"header" + index} className="col-12 col-lg-2 text-center">
                  {name}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody className="well">
          {renderOrder(warenkorbPos)}
        </tbody>
      </table>
    </div>
  );
});
